<template>
  <main>
    <Jumbotron />
    <WelcomeCard />
    <Gathering/>
  </main>
</template>

<script>
import WelcomeCard from '../components/elements/WelcomeCard.vue';
import Jumbotron from '../components/header/Jumbotron';
import Gathering from '../components/elements/Gathering/Gathering.vue';

export default {
  name: 'Overview',
  components: { Jumbotron, WelcomeCard, Gathering },
}
</script>